<ng-template #attente>
  <div class="car-page" style="justify-content: center; align-items: center; min-height: 50vh;">
    <div style="width: 200px;">
      <div class="car-progress-bar">
        <div class="car-progress-bar__inner"></div>
      </div>
      <p class="car-page__subtitle" style="text-align: center;">Mise à jour en cours...</p>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="!generaleService.disabled; else attente">
  <div class="car-page">

    <div class="car-page__header">
      <h1 class="car-page__title">
        <div class="car-page__title-icon">
          <svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="18" height="18">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
          </svg>
        </div>
        Réseaux Sociaux & Équipe
      </h1>
      <p class="car-page__subtitle">Gérez les liens communautaires et les profils des employés</p>
    </div>

    <div class="car-grid" style="grid-template-columns: 1fr;">

      <div class="car-panel">
        <div class="car-panel__header">
          <div class="car-panel__header-left">Configuration des Liens</div>
        </div>

        <div class="car-panel__body">
          <div class="grp-form-strip" style="align-items: flex-end;">

            <div class="grp-img-upload" (click)="openFrmImage('ajouter')" style="margin-right: 8px;">
              <div class="grp-img-upload__preview" style="width: 64px; height: 64px; border-radius: var(--radius-sm);">
                <img [src]="mainImage.File_Content" alt="Main Content Image" />
                <div class="grp-img-upload__overlay">
                  <span>Logo</span>
                </div>
              </div>
            </div>

            <div class="car-field car-field--grow">
              <label class="car-label">Lien Facebook</label>
              <input class="car-input" name="socialFacebookLink" [(ngModel)]="facebook"
                placeholder="https://facebook.com/..." [disabled]="generaleService.disabled" />
            </div>

            <div class="car-field car-field--grow">
              <label class="car-label">Lien Instagram</label>
              <input class="car-input" name="socialInstagramLink" [(ngModel)]="instagram"
                placeholder="https://instagram.com/..." [disabled]="generaleService.disabled" />
            </div>

            <div class="car-field car-field--grow">
              <label class="car-label">Lien Twitter / X</label>
              <input class="car-input" name="socialTwitterLink" [(ngModel)]="tweeter"
                placeholder="https://twitter.com/..." [disabled]="generaleService.disabled" />
            </div>

            <div class="car-toolbar" style="margin-bottom: 2px;">
              <button class="car-btn car-btn--primary" (click)="ajouter()" [disabled]="generaleService.disabled">
                <span *ngIf="generaleService.disabled" class="car-spinner"></span>
                Ajouter
              </button>
              <button class="car-btn car-btn--slate" (click)="modifier()" [disabled]="generaleService.disabled">
                <span *ngIf="generaleService.disabled" class="car-spinner"></span>
                Modifier
              </button>
              <button class="car-btn car-btn--danger" (click)="supprimer()" [disabled]="generaleService.disabled">
                <span *ngIf="generaleService.disabled" class="car-spinner"></span>
                Supprimer
              </button>
            </div>

          </div>
        </div>
      </div>

      <div class="car-panel">
        <div class="car-panel__header">
          <div class="car-panel__header-left">Fiches Descriptives Employés</div>
        </div>
        <div class="car-panel__body">
          <div class="grp-editor-grid">

            <div class="car-field">
              <label class="car-label" style="font-weight: 600; color: var(--tx-base);">Contenu Français</label>
              <div class="grp-editor-container">
                <angular-editor [config]="editorConfig2" name="employeeEditorFr"
                  placeholder="Description des employés en Français..." [(ngModel)]="EmpFr"></angular-editor>
              </div>
            </div>

            <div class="car-field">
              <label class="car-label" style="font-weight: 600; color: var(--tx-base);">Contenu Anglais</label>
              <div class="grp-editor-container">
                <angular-editor [config]="editorConfig2" name="employeeEditorEn"
                  placeholder="Description des employés en Anglais..." [(ngModel)]="EmpEn"></angular-editor>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="car-panel">
        <div class="car-panel__header">
          <div class="car-panel__header-left">Album Galerie Associé</div>
        </div>
        <div class="car-panel__body">
          <div class="grp-gallery-roll">

            <div *ngFor="let img of listeImages; let idx = index" class="grp-gallery-item">
              <div class="grp-gallery-item__img-box" (click)="selectImage(img)">
                <img [id]="img.File_Id" [src]="img.File_Content" alt="Gallery Graphic Row" />
              </div>
              <div class="grp-gallery-item__actions">
                <button class="car-btn car-btn--sm car-btn--slate" style="width: 100%;"
                  (click)="openFrmImage('modifier', img)" [disabled]="generaleService.disabled">
                  <span *ngIf="generaleService.disabled" class="car-spinner"></span>
                  Modifier l'image
                </button>
              </div>
            </div>

            <div *ngIf="!listeImages?.length"
              style="grid-column: 1 / -1; text-align: center; padding: 40px; color: var(--tx-subtle);">
              Aucune image supplémentaire chargée dans cette section.
            </div>

          </div>
        </div>
      </div>

    </div>

    <input id="input_file" type="file" style="display: none;" name="globalCoreImageReceiver"
      (change)="onChangeImagefile($event)">
  </div>
</ng-container>